module.exports = new __parcel__URL__("36910_sq.54542437.jpg").toString();